
import * as customCloudflareRuntime$5ms5gkyjw6 from '/insocial-landing/providers/customCloudflare.ts'
import * as ipxRuntime$ZA7Gci3R5i from '/insocial-landing/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 375,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['customCloudflare']: { provider: customCloudflareRuntime$5ms5gkyjw6, defaults: {"baseURL":"https://imagedelivery.net/cp9N9lAl81VEBJZWdrNT3g/"} },
  ['ipx']: { provider: ipxRuntime$ZA7Gci3R5i, defaults: {} }
}
        